import moment from 'moment'
import {DEVICE_OF_ASSUMPTION_OPTIONS, MODE_OF_ASSUMPTION_OPTIONS, WEEKDAY_OPTIONS} from './therapyDialogsConstants'

export const formatDate = (date?: string, format = 'DD/MM/YYYY') => date ? moment(date).format(format) : ''

export const formatUnitOfMeasure = (dosage?: {value?: number, unitType?: string}) =>
  dosage?.value !== undefined && dosage?.value !== null ? `${dosage.value} ${dosage.unitType}` : ''

export const formatTherapyEach = (each?: {value?: number, unitType?: string}) => {
  const {value, unitType} = each ?? {}
  switch (unitType) {
    case 'HOUR': return value === 1 ? '1 ora' : `${value} ore`
    case 'DAY': return value === 1 ? '1 giorno' : `${value} giorni`
    case 'WEEK': return value === 1 ? '1 settimana' : `${value} settimane`
    case 'MONTH': return value === 1 ? '1 mese' : `${value} mesi`
    default: return `${value} ${unitType}`
  }
}

export const formatWeekDay = (day: string) => WEEKDAY_OPTIONS.find(({value}) => value === day)?.label ?? day

export const formatFrequencyDays = (days: string[] = []) => days.map(formatWeekDay).join(', ')

export const formatModeOfAssumption = (modeKey?: string) => MODE_OF_ASSUMPTION_OPTIONS.find(({value}) => value === modeKey)?.label ?? modeKey ?? ''

export const formatDeviceOfAssumption = (deviceKey?: string) => DEVICE_OF_ASSUMPTION_OPTIONS.find(({value}) => value === deviceKey)?.label ?? deviceKey ?? ''

const THERAPY_STATE_LABELS: Record<string, string> = {
  ACTIVE: 'Attiva',
  NOT_ACTIVE: 'Non attiva'
}

export const formatTherapyState = (state?: string) => state ? (THERAPY_STATE_LABELS[state] ?? state) : ''
